import {useParams} from 'react-router-dom';
import {useCustomPage} from './use-custom-page';
import {FullPageLoader} from '../ui/progress/full-page-loader';
import {Navbar} from '../ui/navigation/navbar/navbar';
import {Helmet} from '../seo/helmet';
import {DefaultMetaTags} from '../seo/default-meta-tags';
import {Footer} from '../ui/footer/footer';

export function CustomPageLayout() {
  const {pageSlug} = useParams();
  const {data} = useCustomPage(pageSlug!);

  return (
    <div className="flex flex-col min-h-full">
      {data?.seo ? <Helmet tags={data.seo} /> : <DefaultMetaTags />}
      <Navbar
        menuPosition="custom-page-navbar"
        className="flex-shrink-0 sticky top-0"
      />
      <div className="flex-auto">
        {!data ? (
          <FullPageLoader />
        ) : (
          <div className="px-16 md:px-24">
            <div className="prose dark:prose-invert mx-auto my-50">
              <h1>{data.page.title}</h1>
              <div dangerouslySetInnerHTML={{__html: data.page.body}} />
            </div>
          </div>
        )}
      </div>
      <Footer className="mx-14 md:mx-40" />
    </div>
  );
}
